<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Upcoming Lots</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
      <img v-if="lots==''" src="../images/nodata.svg">	
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="lots!=''" v-for="lot in lots" :key="lot.id">
          	<td>{{lot.name}}</td>
          	<td>{{lot.description}}</td>
          	<td>{{lot.status}}</td>
          	<td>{{lot.color}}</td>
          	<td>{{lot.liter_weight}}</td>
          	<td>{{lot.net_weight}}</td>
          	<td>{{lot.quote_price}}</td>
          	<td>{{lot.seller}}</td>
          	<td>
          		<button class="btn btn-danger fa fa-cog" @click="gradeLot(lot)"></button>
          	</td>
          </tr>	
        </tbody>
      </datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getLots(pagination.prevPageUrl)"
        @next="getLots(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</section>
    <br>
      <br>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        
        created(){
        	this.getLots();
        },
        
    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'20%', label:'Name', name:'name'},
      			{width:'20%', label:'Description', name:'description'},
      			{width:'10%', label:'Status', name:'status'},
      			{width:'15%', label: 'Color', name:'color'},
      			{width:'5%', label: 'Liter Weight', name:'liter_weight'},
      			{width:'5%', label:'Net Weight', name:'net_weight'},
      			{width:'5%', label:'Quote Price', name:'quote_price'},
      			{width:'10%', label:'Seller', name:'seller'},
      			{width:'10%', label:'Manage', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		lots: []
         }
       },
       
       methods: {
       	configPagination(data){
      		this.pagination.last_page=data.last_page;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
       	
       	getLots(url="/api/getAvailableLots"){
       		axios.post(url, {params: this.tableData, am: 'false'})
       		.then(response => {
       			this.lots = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},
       	
       	gradeLot(lot){
        		this.$router.push("/home/buyer/lot-details/"+lot.id);
        	}
       	/*,
        
        change(role, code, id){
        	switch(role){
        		case 'admin':
        			axios.post('/api/changeAdminStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'auctioneer':
        			axios.post('/api/changeAuctioneerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'seller':
        			axios.post('/api/changeSellerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		case 'buyer':
        			axios.post('/api/changeBuyerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers();
        			});
        			break;
        		default:
        			console.log("Null");
        	}
        }*/
      }
    }
</script>
